import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonContainer } from "app/utils/json-container";
import { RestService } from "app/utils/rest-service";
import { StorageUtils } from "app/utils/storage-utils";


@Injectable()
export class RequestNotificationService extends RestService {

    private baseUrl: string;

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'requestNotification', storageUtils);
    }

    list(idUser: string, callback: (result: JsonContainer, list: any) => void) {
        this.executeGet('listNotificationByUser/' + idUser, callback)
    }

    save(request: Request, callback: (result: JsonContainer, resp: any) => void) {
        this.executePost('save', request, callback)
    }

    view(id: string, callback: (result: JsonContainer, resp: any) => void) {
        this.executeGet('viewNotification/' + id, callback)
    }

}


